export default `
fragment UserBookStatusFragment on user_books {
  bookId:book_id
  userId:user_id
  statusId:status_id
}
`;
